import { ResetFormData } from 'components/ResetPassword/interface';
import { SetPasswordPayload } from 'utils/api/users/types';

export const mapDataForBackend = (data: ResetFormData, id: string): SetPasswordPayload => {
  const { password, confirmPassword } = data;

  return {
    token: id,
    password: password,
    repeated_password: confirmPassword,
  };
};
